export default __webpack_public_path__ + "static/android-icon-192x192-098143b8bead0a0be7163042fab468fa.png";